<template>
  <div>
    <shimmer v-if="withTitle" height="18px" width="80%"></shimmer>
    <shimmer width="100%" height="0.9rem" class="line-box my-1"></shimmer>
    <shimmer width="80%" height="0.9rem" class="line-box mb-1"></shimmer>
    <!-- <shimmer
      :width="justified ? '100%' : '90%'"
      :rounded="true"
      height="0.8rem"
      class="line-box"
    ></shimmer>-->
  </div>
</template>
<script>
import shimmer from '@/components/shimmers/shimmer'

export default {
  props: {
    withTitle: {
      default: false,
      type: Boolean
    },
    justified: {
      default: false,
      type: Boolean
    }
  },
  components: {
    shimmer
  }
}
</script>

<style scoped>
.line-box {
  height: 1.25rem;
}
</style>
